import { ProductHighlightPill } from '../ProductHighlightPill';

import {
    StyledCardBody,
    StyledCardDescription,
    StyledCardHeader,
    StyledCardHeadline,
    StyledCardSection,
    StyledCardSubHead,
    StyledCardTitle,
} from './PromoCard.styled';
import { PromoCardProperties } from './PromoCard.types';

export const PromoCard = ({
    id,
    color,
    title,
    headline,
    subHead,
    description,
    pill,
    isCarouselChild,
}: PromoCardProperties) => {
    return (
        <StyledCardSection id={id} $isCarouselChild={isCarouselChild}>
            <StyledCardHeader data-testid="promoCardHeader" $color={color}>
                <StyledCardTitle>{title}</StyledCardTitle>
                <StyledCardHeadline>{headline}</StyledCardHeadline>
                {pill?.text && (
                    <ProductHighlightPill {...pill} className="promoCardPill" />
                )}
            </StyledCardHeader>
            <StyledCardBody className="promoCardBody">
                <StyledCardSubHead data-sub-head>{subHead}</StyledCardSubHead>
                <StyledCardDescription gutterBottom={false}>
                    {description}
                </StyledCardDescription>
            </StyledCardBody>
        </StyledCardSection>
    );
};
